import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <section id="categories" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">
          {t('category.browse')}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
          {t('category.hint')}
        </p>
      </div>

      <div className="relative mx-auto mt-8 max-w-md">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex w-full items-center justify-between rounded-md border border-background-300 bg-background-50 px-4 py-3 text-left text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 cursor-pointer"
        >
          <span className="flex items-center gap-2">
            <i className="ri-menu-2-line text-base text-primary-600" />
            {t('category.label')}
          </span>
          <i className={`ri-arrow-down-s-line text-base text-foreground-500 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>

        {open && (
          <div className="absolute left-0 right-0 z-20 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-1">
            {categories.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-background-100"
              >
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-background-100 text-primary-600">
                  <i className={`${cat.icon} text-sm`} />
                </span>
                {t(cat.nameKey)}
              </a>
            ))}
          </div>
        )}
      </div>

      <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 lg:gap-5">
        {categories.map((cat) => (
          <a
            key={cat.id}
            href={cat.url}
            target="_blank"
            rel="noopener nofollow"
            className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-400"
          >
            <div className="relative h-40 w-full overflow-hidden">
              <img
                src={cat.image}
                alt={t(cat.nameKey)}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between px-4 py-3">
              <span className="text-sm font-medium text-foreground-900">{t(cat.nameKey)}</span>
              <span className="flex h-6 w-6 items-center justify-center text-primary-600">
                <i className="ri-arrow-right-up-line text-sm" />
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}